import { getDomain, getEnvironment, isDev } from '@library/environment/isomorphic'
import { composeFetch } from '@library/http'
import { addPath, composeRequest, goustoHeaders, setHost, setMethod } from '@library/http/requests'

import type { LandingExperienceData, LandingExperienceResponse } from './interfaces'

const LOCAL_API_HOST = 'https://staging-api.gousto.info'

function getActivateApiHost() {
  if (isDev()) {
    return LOCAL_API_HOST
  }

  return `https://${getEnvironment()}-api.${getDomain()}`
}

const parseLandingExperience = async (response: Response): Promise<LandingExperienceResponse> => {
  if (response.status === 204) {
    return { status: 204, data: null }
  }

  if (!response.ok) {
    const responseMessage = await response.text()
    throw new Error(
      `landing-experience service responded with ${response.status}: ${responseMessage}`,
    )
  }

  const body = (await response.json()) as { data: LandingExperienceData }
  return { status: 200, data: body.data }
}

export const fetchLandingExperience = composeFetch(
  composeRequest(
    setHost(getActivateApiHost),
    addPath('ux/engagement/v1/landing-experience'),
    setMethod('GET'),
    goustoHeaders,
  ),
  parseLandingExperience,
)
